import React, { Component, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid } from '@material-ui/core';
import { ErrorIcon, SuccessIcon } from '../../components/icons'
import Button from '../../components/ButtonCustom';
import { formatDateTimeToShortMonthName } from '../../utils/util';
import Container from '../../components/Container';
import { getCurrency } from '../../utils/common';
import crmservices from '../../wsclient/';
import ModalAlert from '../../components/ModalAlert';
import Cookies from 'js-cookie';
const queryString = require('query-string');
function PaymayaTopUpResult(props) {
    const [showLoading, onShowLoading] = useState(true);
    const [message, setMessage] = useState({});
    const [topupResult, setTopupResult] = useState({});
    const [ready, setReady] = useState(false);


    useEffect(() => {
        const parsed = queryString.parse(props.location.search);
        if (parsed.timestamp) {
            let refNumber = Cookies.get("paymaya_" + parsed.timestamp);
            if (refNumber) {
                loadTopUpResult(refNumber, parsed.timestamp);
            } else {
                props.history.push('/home')
                Cookies.remove("paymaya_" + parsed.timestamp);
            }
        } else {
            props.history.push('/home');
        }

    }, [])

    const loadTopUpResult = async (refNumber, timestamp) => {
        try {
            const result = await crmservices.cignalservices.getTopUpResult({
                request_reference_number: refNumber
            })
            Cookies.remove("paymaya_" + timestamp);
            onShowLoading(false);
            setReady(true);
            setTopupResult(result.data);
        } catch (ex) {
            showMessage(t('EXCEPTION_PROCESS'))
        }
    }

    const showMessage = async (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

    const { classes, t } = props;

    let currency = getCurrency();
    console.log("topupResult===", topupResult);
    if (ready)
        return (
            <Container showLoading={showLoading}>
                <Grid xs={12} item>
                    <Grid xs={12} item justify='center' container>
                        {topupResult.status == "COMPLETTED" && <SuccessIcon style={{ width: 100, height: 100 }} />}
                        {topupResult.status != "COMPLETTED" && <ErrorIcon style={{ width: 100, height: 100 }} />}
                    </Grid>
                    {topupResult.type=='TOP_UP' && <Grid xs={12} item justify='center' container>
                        {topupResult.status == "COMPLETTED" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t("TOPUP_SUCCESS")}</Typo>}
                        {topupResult.status != "COMPLETTED" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('TOPUP_FAILED')}</Typo>}
                    </Grid>}
                    {topupResult.type=='PAYMENT' && <Grid xs={12} item justify='center' container>
                        {topupResult.status == "COMPLETTED" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t("PAYMENT_SUCCESS")}</Typo>}
                        {topupResult.status != "COMPLETTED" && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('PAYMENT_FAILED')}</Typo>}
                    </Grid>}
                    <Grid xs={12} item justify='center' container style={{ marginTop: 32 }}>
                        <Grid xs={12} sm={12} md={5} className={classes.boxItemContent}>
                            <Grid xs={12} item container direction='row'>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle1">{'Reference Number'}</Typo>
                                </Grid>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle2">{topupResult.request_reference_number}</Typo>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item container direction='row' style={{ marginTop: 8 }}>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle1">{t('Amount')}</Typo>
                                </Grid>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle2">{currency}{topupResult.amount ? Number(topupResult.amount).toFixed(2) : "0.00"}</Typo>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item container direction='row' style={{ marginTop: 8 }}>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle1">{t('Created Date')}</Typo>
                                </Grid>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle2">{topupResult.updatedAt ? formatDateTimeToShortMonthName(topupResult.updatedAt) : ""}</Typo>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item container direction='row' style={{ marginTop: 8 }}>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle1">{t('Status')}</Typo>
                                </Grid>
                                <Grid xs={6} item>
                                    <Typo variant="subtitle2" color={topupResult.status == "COMPLETTED" ? "success" : "error"}>{topupResult.status}</Typo>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid xs={12} item container justify='center' style={{ marginTop: 32 }}>
                        <Grid xs={3} item container >
                            <Button color='primary' fullWidth onClick={() => props.history.push('/home')}>{t('Back to Home Page')}</Button>
                        </Grid>
                    </Grid>
                </Grid>
                {message && <ModalAlert
                    open={message.show}
                    onClose={showMessage}
                    message={message.content}
                />}
            </Container >
        );
    else {
        return (
            <Container showLoading={showLoading}>

            </Container>
        )
    }
}

const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
    },
});
export default withStyles(styles)(withTranslation()(PaymayaTopUpResult));